import instance from "../utils/api_instance.util.js";

export const fetchDiscountList = async (url) => {
    try {
        const { data } = await instance.get('/api/v1/discount/fetchDiscountList');
        return data;
    } catch (err) {
        throw err;
    }
}

export const getAdminDiscountList = async (url) => {
    try {
        const { data } = await instance.get('/api/v1/discount/getDiscountListForAdmin');
        return data;
    } catch (err) {
        throw err;
    }
}

export const createDiscountData = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/discount/createDiscount', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const updateDiscountData = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/discount/updateDiscount', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const updateDiscountStatus = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/discount/updateDiscountStatus', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}